import { defineMessages } from "react-intl";

export const messages = defineMessages({
    customersNavLabel: {
        id: "fastshift-portal.page-layout.nav.customers-label",
        defaultMessage: "Customers",
        description: "Navigation label for customers page"
    },
    resourcesNavLabel: {
        id: "fastshift-portal.page-layout.nav.resources-label",
        defaultMessage: "Resources",
        description: "Navigation label for resources page"
    },
    forYouNavLabel: {
        id: "fastshift-portal.page-layout.nav.for-you-label",
        defaultMessage: "For You",
        description: "Navigation label for for you page"
    },
    migrationPlanningNavLabel: {
        id: "fastshift-portal.page-layout.nav.migration-planning-label",
        defaultMessage: "Migration Planning",
        description: "Navigation label for migration planning page"
    },
    migrationTicketsNavLabel: {
        id: "fastshift-portal.page-layout.nav.migration-tickets-label",
        defaultMessage: "Migration Tickets",
        description: "Navigation label for migration tickets page"
    },
    collapseSidebarLabel: {
        id: "fastshift-portal.page-layout.sidebar.collapse-label",
        defaultMessage: "Collapse sidebar",
        description: "Label for collapse sidebar button"
    },
    expandSidebarLabel: {
        id: "fastshift-portal.page-layout.sidebar.expand-label",
        defaultMessage: "Expand sidebar",
        description: "Label for expand sidebar button"
    },
    fastshiftAppName: {
        id: "fastshift-portal.page-layout.app.name",
        defaultMessage: "Fastshift",
        description: "Application name for Fastshift"
    },
    homePageLabel: {
        id: "fastshift-portal.page-layout.app.home-page-label",
        defaultMessage: "Home page",
        description: "Label for home page link"
    },
    customersBackLabel: {
        id: "fastshift-portal.page-layout.nav.customers-back-label",
        defaultMessage: "Customers",
        description: "Label for back to customers link in sidebar header"
    },
    logoAltText: {
        id: "fastshift-portal.page-layout.logo.alt-text",
        defaultMessage: "{name} logo",
        description: "Alt text for the company logo of the selected customer"
    },
    betaLozenge: {
        id: "fastshift-portal.page-layout.app.beta-lozenge",
        defaultMessage: "Beta",
        description: "Beta lozenge"
    }
});
